module.exports = __webpack_public_path__ + "img/ic_point_3.fd993c2f.svg";